import { createContext } from 'react';

/**
 * The chat composer's "attach a file" entry point, for tool cards that bring a
 * file in on the user's behalf (a pasted Google Sheet). Attaching stages the
 * usual import mapping card. Null outside the chat thread.
 */
export const CopilotAttachContext = createContext<
  ((files: File[]) => void) | null
>(null);
